<template>
    <div>

        <!--create & delete 버튼-->
        <v-row>
            <!-- <v-col cols="5">
                <div class="application_account_wrap">
                    <div class="application_account">
                        <div class="applicationtype live">
                            <span>LIVE</span>
                        </div>
                        <div class="accoun">
                            <span class="txt">송출 수</span>
                            <span>2개</span>
                        </div>
                    </div>

                    <div class="application_account pull">
                        <div class="applicationtype pull">
                            <span>PULL</span>
                        </div>
                        <div class="accoun">
                            <span class="txt">송출 수</span>
                            <span>2개 / 20개</span>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon class="mdi mdi-information-symbol ml-1 pull_info" v-bind="attrs" v-on="on"
                                        color="#ccc" />
                                </template>
                                <div>
                                    <span style="font-size: 12px;">rtsp pull 라이브는 최대 20개까지만 동시 송출이 가능합니다.</span>
                                </div>

                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </v-col> -->

            <v-col class="text-right mb-2">
                <TextButton buttonText="생성" isPrimary class="mr-2" @click="openModal" />

                <!--라이브 생성 modal-->
                <AppDialog :value="modalOpen" @input="modalOpen = $event" :persistent="true">

                    <template v-slot:title>
                        라이브 생성
                    </template>

                    <template v-slot:content>
                        <!-- <Alert :message="message" :message-type="messageType"></Alert> -->

                        <div class="suport_box">
                            원하는 <strong>라이브 타입</strong>을 선택해주세요.
                        </div>
                        <v-btn-toggle v-model="live_type" borderless class="mb-2" style="width: 50%;height: 40px;">
                            <v-btn block height="40px" style="border: 1px solid #bbb;" :value="'live'">
                                <span class="hidden-sm-and-down">Live</span>
                            </v-btn>

                            <v-btn block height="40px" style="border: 1px solid #bbb;" :value="'pull'">
                                <span class="hidden-sm-and-down">PULL</span>
                            </v-btn>
                        </v-btn-toggle>

                        <div class="mt-2">
                            <h4>스트리밍 명</h4>
                            <Input :message-type="messageType" placeholder="스트리밍 명을 입력해주세요." v-model="stream_name"
                                class="text-right" />
                            <AppInputAlert :message="message" :message-type="messageType" class="mb-5"></AppInputAlert>
                        </div>

                        <div class="mt-4" v-if="live_type === 'pull'">
                            <h4>URL</h4>
                            <Input placeholder="URL을 입력해주세요." v-model="uri" />
                        </div>

                    </template>
                    <template v-slot:actions>
                        <TextButtonBlock buttonText="취소" @click="closeModal" />
                        <TextButtonBlock buttonText="저장" isPrimary @click="createLive" />
                    </template>


                </AppDialog>
                <IconButton icon="mdi-trash-can-outline" :disabled="selected.length === 0 || !allItemsSameType || selected.some(item => item.status === 1)
                    || selected.some(item => item.recordStatus === 1)" @click="deleteLiveItem" class="mr-2" small/>
            </v-col>
        </v-row>

        <!--live 관리 data table-->
        <v-data-table :headers="headers" :items="lives" :items-per-page="10"
            :footer-props="{ itemsPerPageOptions: [10, 20, 30, -1], itemsPerPageText: 'All' }" class="data-table"
            :disable-sort="true" show-select v-model="selected" :key="lives.id">

            <template v-slot:item.status="{ item }">
                <!-- <div v-if="item.status  === 0" style="color: #c82727;" class="status-container">
                    <v-icon class="status-icon mdi mdi-message-alert-outline mr-1" dense color="#c82727"></v-icon>
                </div>
                <div v-else-if="item.status  === 1" style="color: #388E3C;" class="status-container">
                    <v-icon class="status-icon mdi mdi-check-circle-outline mr-1" dense color="#388E3C"></v-icon>
                </div> -->
                <div v-if="item.status === 0">
                    <span class="reco_status recording_off">
                        <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                        라이브
                    </span>
                </div>
                <div v-else-if="item.status === 1">
                    <span class="reco_status recording_on">
                        <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                        라이브
                    </span>
                </div>
            </template>

            <template v-slot:item.recordStatus="{ item }">
                <!-- <div v-if="item.record_status === 0" style="color: #c82727;" class="status-container">
                    <v-icon class="status-icon mdi mdi mdi-message-alert-outline mr-1" dense color="#c82727"></v-icon>
                </div>
                <div v-else-if="item.record_status === 1" style="color: #388E3C;" class="status-container">
                    <v-icon class="status-icon mdi mdi-check-circle-outline mr-1" dense color="#388E3C"></v-icon>
                </div> -->
                <div v-if="item.recordStatus === 0">
                    <span class="reco_status recording_off">
                        <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                        녹화
                    </span>
                </div>
                <div v-else-if="item.recordStatus === 1">
                    <span class="reco_status recording_on">
                        <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                        녹화
                    </span>
                </div>
                <!--영상을 준비하는 중에 대한 status-->
                <!-- <div>
                    <span class="reco_status recording_waiting">
                        <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333"/>
                        준비중
                    </span>
                </div> -->
            </template>

            <!--live & pull status chip-->
            <template v-slot:item.type="{ item }">
                <template v-if="item.type === 'live'">
                    <v-chip color="#FFF8D1" text-color="#E8B500" small>
                        <v-avatar left><v-icon small>mdi-access-point</v-icon></v-avatar>LIVE
                    </v-chip>
                </template>

                <template v-else-if="item.type === 'pull'">
                    <v-chip color="#f0f4ff" text-color="#0040ff" small>
                        <v-avatar left><v-icon small>mdi-record-circle-outline</v-icon></v-avatar>PULL
                    </v-chip>
                </template>
            </template>

            <template v-slot:item.view="{ item }">
                <v-btn dark elevation="0" small @click="goAction(item)">View</v-btn>
            </template>
        </v-data-table>

        <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />




    </div>
</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
//import Input from '@/components/app/AppFormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import AppDialog from '@/components/app/AppDialog.vue';
import { mapState } from 'vuex';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import AppInputAlert from '@/components/app/AppInputAlert.vue';

export default {
    components: {
        Input,
        TextButton,
        TextButtonBlock,
        IconButton,
        AppDialog,
        AppSnackbar,
        AppInputAlert,
    },
    data() {
        return {
            headers: [
                { text: '스트리밍 명', value: 'stream_name' },
                { text: '라이브 상태', value: 'status' },
                { text: '레코딩 상태', value: 'recordStatus' },
                { text: '라이브 타입', value: 'type' },
                { text: '라이브 관리', value: 'view' },
            ],
            lives: [],
            selected: [],
            stream_name: '',
            modalOpen: false,
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            snackbarErrorText: '',
            live_type: 'live',
            message: '',
            messageType: '',
            uri: '',
        }
    },
    async mounted() {
        await this.wowzadbCheck();
    },
    methods: {
        async pullLoadBalancer() {
            const data = {
                ip: `${window.location.protocol}//${window.location.host}`,
            };
            try {
                const response = await LiveStreamApi.pullLoadBalancerApi(data);
                if (response.status === 1) {
                    console.log('호출 성공');
                }
            } catch (error) {
                console.error('error', error);
            }
        },
        async deleteLiveItem() {
            if (this.selected.length > 0 && !this.selected.some(server => server.live_status === 1 &&
                !this.selected.some(server => server.record_status === 1)
            )) {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ids: this.selected.map(server => server.id),
                    ip: frontUrl,
                };
                try {
                    const response = await LiveStreamApi.deleteApi(data);
                    //console.log('res', response);
                    if (response.status === 1) {
                        this.snackbarText = '삭제 성공';
                        this.snackbarError = false;
                        this.snackbar = true;
                        this.selected = [];
                        this.getLiveList();
                    }
                } catch (error) {
                    console.error('error', error);
                    this.snackbarText = '삭제 실패';
                    this.snackbarError = true;
                    this.snackbar = true;
                }
            } else {
                //console.log('error');
                this.snackbarText = '삭제 실패';
                this.snackbarError = true;
                this.snackbar = true;
            }

            setTimeout(() => {
                this.snackbar = false;
                this.snackbarError = false;
            }, 10000);

        },
        async closeModal() {
            this.modalOpen = false;
            this.message = '';
            this.messageType = '';
            this.stream_name = '';
            this.uri = '';
        },
        async wowzadbCheck() {
            const response = await LiveStreamApi.wowzaCheckApi();
            const statusFail = response.status;

            if (statusFail === 0) {
                this.$router.push('/mediaerror');
            } else if (statusFail === 3) {
                // this.showAlertText = response.data.message;
                // this.showAlert3 = true;
                // this.isDisabled = true;
                this.$router.push('/mediaerror');
            } else {
                //this.isDisabled = false;
                await this.pullLoadBalancer();
                this.getLiveList();
            }
        },
        async createLive() {
            const trimmedName = this.stream_name.trim();

            if (!trimmedName) {
                this.message = '라이브 이름을 넣어주세요';
                this.messageType = 'warning';

                setTimeout(() => {
                    this.message = '';
                    this.messageType = '';
                }, 5000);

                return;
            }

            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            this.showAlert = false;

            if (this.live_type === 'pull') {
                const requestData = {
                    stream_name: this.stream_name,
                    ip: frontUrl,
                    type: this.live_type,
                    uri: this.uri,
                };

                const response = await LiveStreamApi.addApi(requestData);
                if (response.status === 200) {
                    this.loading = false;
                    this.selected = [];
                    this.stream_name = '';
                    this.snackbarText = '생성 성공';
                    this.snackbarError = false;
                    this.uri = '';
                    this.snackbar = true;
                    this.getLiveList();
                    this.modalOpen = false;
                } else if (response.status === 0) {
                    this.message = '스트리밍 명이 중복됩니다.';
                    this.messageType = 'error';
                } else if (response.status === 2) {
                    this.message = '생성 실패하였습니다.';
                    this.messageType = 'error';
                }

            } else {
                const requestData = {
                    stream_name: this.stream_name,
                    ip: frontUrl,
                    type: this.live_type,
                };

                const response = await LiveStreamApi.addApi(requestData);

                if (response.status === 200) {
                    this.loading = false;
                    this.selected = [];
                    this.stream_name = '';
                    this.snackbarText = '생성 성공';
                    this.snackbarError = false;
                    this.snackbar = true;
                    this.getLiveList();
                    this.modalOpen = false;
                } else if (response.status === 0) {
                    this.message = '스트리밍 명이 중복됩니다.';
                    this.messageType = 'error';
                } else if (response.status === 2) {
                    this.message = '생성 실패하였습니다.';
                    this.messageType = 'error';
                }
            }


            setTimeout(() => {
                this.snackbar = false;
                this.snackbarError = false;
            }, 10000);

        },
        async getLiveList() {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                };
                const response = await LiveStreamApi.listApi(data);
                // console.log('res', response);
                // this.lives = response.data;
                this.lives = response.data.map(item => ({
                    ...item,
                    status: item.type === 'live' ? item.live_status : item.pull_stream_status,
                    recordStatus: item.type === 'live' ? item.record_status : item.pull_record_status,
                }));

            } catch (error) {
                console.error('list error', error);
                return [];
            }
        },
        async goAction(item) {
            if (item.type === 'live') {
                this.$router.push({ path: '/wowzastream/wowzalivestream_view/' + item.uuid });
            } else if (item.type === 'pull') {
                this.$router.push({ path: '/wowzastream/wowzalivepullstream_view/' + item.uuid });
            }

        },
        openModal() {
            this.live_type = 'Live';
            this.modalOpen = true;
        },
        saveAction() {
            this.modalOpen = false;
        }
    },
    watch: {
        lastSaved(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.getLiveList();
            }
        }
    },
    computed: {
        ...mapState('livestatus', ['lastSaved']),
        allItemsSameType() {
            if (this.selected.length === 0) return true;
            const firstType = this.selected[0].type;
            return this.selected.every(item => item.type === firstType);
        }
    },
}
</script>

<style scoped>
.alert-active input {
    border: 1px solid red;
}

.application_account_wrap {
    display: flex;
}

.application_account {
    display: flex;
    background: #fff;
    padding: 6px;
    width: 140px;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-right: 6px;
}

.application_account.pull {
    width: 210px;
}

.application_account_wrap .accoun {
    font-size: 13px;
    color: #999;
}

.application_account_wrap .accoun .txt {
    border-right: 1px solid #ddd;
    padding-right: 8px;
    margin-right: 8px;
    height: 4px;
}

.pull_info {
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 18px;
    height: 18px;
}

.applicationtype {
    padding: 1px 8px 1px 8px;
    border-radius: 2px;
    font-size: 12px;
    margin-right: 8px;
}

.applicationtype.live {
    background: #FFF8D1;
    color: #E8B500;
}

.applicationtype.pull {
    background: #f0f4ff;
    color: #0040ff;
}
</style>